var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1832_53191",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "#C0C0C0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1832_53191)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 87.5002C14.375 87.5002 12.4132 86.6842 10.7813 85.0523C9.14935 83.4203 8.33337 81.4585 8.33337 79.1668V33.3335C8.33337 31.0418 9.14935 29.08 10.7813 27.4481C12.4132 25.8161 14.375 25.0002 16.6667 25.0002H33.3334V16.6668C33.3334 14.3752 34.1493 12.4134 35.7813 10.7814C37.4132 9.14947 39.375 8.3335 41.6667 8.3335H58.3334C60.625 8.3335 62.5868 9.14947 64.2188 10.7814C65.8507 12.4134 66.6667 14.3752 66.6667 16.6668V25.0002H83.3334C85.625 25.0002 87.5868 25.8161 89.2188 27.4481C90.8507 29.08 91.6667 31.0418 91.6667 33.3335V79.1668C91.6667 81.4585 90.8507 83.4203 89.2188 85.0523C87.5868 86.6842 85.625 87.5002 83.3334 87.5002H16.6667ZM16.6667 79.1668H83.3334V33.3335H16.6667V79.1668ZM41.6667 25.0002H58.3334V16.6668H41.6667V25.0002Z",
    fill: "#002E40"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProject);
export default __webpack_public_path__ + "static/media/Project.600a88893a2e9b9e791cc4e562041a5c.svg";
export { ForwardRef as ReactComponent };